import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PAPER } from "../notes/EnvelopeMemories";

function SealedEnvelope() {
  return (
    <svg viewBox="0 0 240 160" className="h-full w-full drop-shadow-[0_24px_40px_rgba(126,87,194,0.35)]" aria-hidden>
      <defs>
        <linearGradient id="open-body" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#FDEAF3" />
          <stop offset="0.55" stopColor="#EFE4FB" />
          <stop offset="1" stopColor="#DCEEFB" />
        </linearGradient>
        <linearGradient id="open-flap" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#F9C9E0" />
          <stop offset="1" stopColor="#D7C5F3" />
        </linearGradient>
        <radialGradient id="open-seal" cx="0.4" cy="0.35" r="0.7">
          <stop offset="0" stopColor="#E58FB4" />
          <stop offset="1" stopColor="#B4467A" />
        </radialGradient>
      </defs>
      <rect x="4" y="12" width="232" height="144" rx="12" fill="url(#open-body)" stroke="#fff" strokeWidth="3" />
      <path d="M8 152 L120 84 L232 152" fill="none" stroke="#fff" strokeOpacity="0.9" strokeWidth="3" />
      <path d="M6 16 L120 98 L234 16" fill="url(#open-flap)" stroke="#fff" strokeWidth="3" strokeLinejoin="round" />
      <circle cx="120" cy="100" r="19" fill="url(#open-seal)" />
      <path d="M120 108 C112 101 108 96 111 92 C114 88 118 90 120 94 C122 90 126 88 129 92 C132 96 128 101 120 108 Z" fill="#FCE4EF" />
    </svg>
  );
}

export function OpeningLetter({ note, signature = "Priyanka", onClose, preview = false }) {
  const [opened, setOpened] = useState(false);
  return (
    <motion.div
      data-testid="opening-overlay"
      data-preview={preview}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 0.9 } }}
      transition={{ duration: 1 }}
      className="fixed inset-0 z-[95] flex items-center justify-center overflow-y-auto bg-[#2A1B3D]/25 p-5 backdrop-blur-sm"
    >
      <AnimatePresence mode="wait">
        {!opened ? (
          <motion.button
            key="env"
            data-testid="opening-envelope"
            onClick={() => setOpened(true)}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -30, scale: 0.94, transition: { duration: 0.7 } }}
            transition={{ duration: 1.2 }}
            className="group flex flex-col items-center gap-4"
          >
            <span className="opening-float h-44 w-64 -rotate-2 transition-transform duration-500 group-hover:scale-[1.03] sm:h-56 sm:w-80">
              <SealedEnvelope />
            </span>
            <span className="font-hand text-3xl text-[#4A2D55]">A note from Priyanka</span>
            <span className="text-[10px] uppercase tracking-[0.35em] text-[#5C4A72]">tap to open</span>
          </motion.button>
        ) : (
          <motion.div
            key="letter"
            data-testid="opening-letter"
            initial={{ opacity: 0, y: 60, rotateX: 18 }}
            animate={{ opacity: 1, y: 0, rotateX: 0 }}
            transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
            style={{ ...PAPER, transformPerspective: 900 }}
            className="relative w-full max-w-md rounded-[6px] px-7 py-8 shadow-[0_30px_70px_-30px_rgba(91,58,133,0.6)] sm:px-10 sm:py-10"
          >
            <p data-testid="opening-letter-text" className="whitespace-pre-wrap break-words font-hand text-[25px] leading-[1.3] text-[#3B2656] sm:text-[27px]">
              {note}
            </p>
            <p data-testid="opening-letter-signature" className="mt-6 text-right font-hand text-3xl text-[#9C5A86]">
              {signature}
            </p>
            <div className="mt-8 flex justify-center">
              <button
                data-testid="opening-letter-close"
                onClick={onClose}
                className="rounded-full border border-[#7E57C2]/30 bg-white/70 px-7 py-2.5 text-[11px] uppercase tracking-[0.3em] text-[#3B2656] transition-colors duration-300 hover:bg-[#7E57C2] hover:text-white"
              >
                {preview ? "Close preview" : "Step inside"}
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}
